import React from "react";

export interface HeadingProps extends React.HTMLAttributes<HTMLHeadingElement> {
 as?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
 size?: "xs" | "sm" | "md" | "lg" | "xl" | "2xl" | "3xl";
 weight?: "normal" | "medium" | "semibold" | "bold";
}

const sizeClasses = {
 xs: "text-xs",
 sm: "text-sm",
 md: "text-base",
 lg: "text-lg",
 xl: "text-xl",
 "2xl": "text-2xl",
 "3xl": "text-3xl sm:text-4xl",
};

const weightClasses = {
 normal: "font-normal",
 medium: "font-medium",
 semibold: "font-semibold",
 bold: "font-bold",
};

export const Heading: React.FC<HeadingProps> = ({
 as: Component = "h2",
 size = "lg",
 weight = "semibold",
 className = "",
 children,
 ...props
}) => {
 return (
  <Component
   className={`${sizeClasses[size]} ${weightClasses[weight]} ${className}`}
   {...props}
  >
   {children}
  </Component>
 );
};

export default Heading;

